<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M231.974 170.323C231.539 170.323 231.111 170.362 230.688 170.413C231.578 168.614 232.096 166.598 232.096 164.454C232.096 157.03 226.08 151.014 218.656 151.014C215.462 151.014 212.538 152.134 210.227 153.99C207.367 149.658 202.458 146.803 196.877 146.803C188.045 146.803 180.877 153.965 180.877 162.803C180.877 163.789 180.973 164.749 181.139 165.683C180.896 165.67 180.659 165.645 180.416 165.645C173.395 165.645 167.706 171.334 167.706 178.355C167.706 184.595 172.211 189.779 178.144 190.854C178.432 190.982 178.746 191.053 179.078 191.053H180.102C180.205 191.053 180.314 191.066 180.416 191.066C180.518 191.066 180.627 191.053 180.736 191.046L231.238 191.021C231.238 191.021 231.29 191.014 231.322 191.014C231.539 191.027 231.75 191.046 231.968 191.046C237.69 191.046 242.33 186.406 242.33 180.685C242.33 174.963 237.69 170.323 231.968 170.323H231.974Z"
      class="fill-brand-100"
    />
    <path
      d="M215.533 214.874C212.742 212.083 208.211 212.083 205.421 214.874L184.915 235.379L154.771 205.235C151.974 202.438 147.443 202.438 144.646 205.235L99.6992 250.182C99.3856 250.496 99.104 250.829 98.8352 251.174H251.827L215.533 214.88V214.874Z"
      class="fill-brand-500"
    />
    <path
      d="M45.2673 113.242C46.2912 111.725 46.8928 109.895 46.8928 107.93C46.8928 105.965 46.2977 104.141 45.2737 102.624C45.3953 102.445 45.5041 102.266 45.6129 102.08C48.2369 97.5297 46.6753 91.6929 42.1249 89.0625L21.6385 77.2353C19.4369 75.9617 16.8641 75.6289 14.4065 76.2817C11.9489 76.9409 9.89445 78.5153 8.62085 80.7233C5.99685 85.2737 7.55845 91.1105 12.1089 93.7409L20.1921 98.4065H13.7025C8.44805 98.4065 4.17285 102.682 4.17285 107.936C4.17285 113.191 8.44805 117.466 13.7025 117.466H20.1921L12.1089 122.131C7.55845 124.755 5.99685 130.599 8.62085 135.149C10.3809 138.202 13.5937 139.911 16.8897 139.911C18.5025 139.911 20.1409 139.501 21.6385 138.637L42.1249 126.81C44.3265 125.536 45.9073 123.482 46.5665 121.024C47.2257 118.567 46.8865 116 45.6129 113.792C45.5041 113.607 45.3825 113.434 45.2673 113.255V113.242Z"
      class="fill-brand-100"
    />
    <path
      d="M220.608 124.941H124.973V86.0481H157.491C194.893 86.5409 213.811 107.52 220.608 124.941Z"
      class="fill-brand-100"
    />
    <path
      d="M185.862 109.651C188.817 109.651 191.213 107.256 191.213 104.301C191.213 101.346 188.817 98.9504 185.862 98.9504C182.908 98.9504 180.512 101.346 180.512 104.301C180.512 107.256 182.908 109.651 185.862 109.651Z"
      class="fill-brand-500"
    />
    <path
      d="M77.1521 4.82568V82.4513L45.3505 92.1025V123.795L77.1521 133.427V211.034C119.802 196.192 150.419 155.642 150.419 107.93C150.419 60.2177 119.808 19.6673 77.1521 4.82568Z"
      class="fill-secondary-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Independent'
  }
</script>
